<template>
  <div class="user-wrapper">
    <!-- <el-tooltip content="使用帮助">
      <span class="action">
        <i class="el-icon-question"></i>
      </span>
    </el-tooltip> -->

    <!-- 消息盒子 -->
    <!-- <el-tooltip content="点击查看消息">
      <z-message class="action" :option="zMessageOption"/>
    </el-tooltip> -->

    <el-dropdown @command="handleCommand">
      <span class="action antel-link user-dropdown-menu">
        <img v-if="avatar" :src="avatar" class="avatar">
        <img class="avatar" src="../../assets/avatar.png"/>
        <span>{{ userInfo.userName }}</span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <!--<el-dropdown-item>账户设置</el-dropdown-item> -->
        <el-dropdown-item command="SetPass">重置支付密码</el-dropdown-item>
        <el-dropdown-item command="Logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!--只有ka市场有这个入库-->
    <a v-if="marketCodes && marketCodes.includes('10606')" class="mall-btn" :href="hrefUrl" target="_blank">前往商城</a>

    <forget-pass @closeMain="closeMain" v-if="isDisplay" editType='2'></forget-pass>
    <set-pass @closeMain="closeMain" v-if="isSetDisplay" :userId="userId"></set-pass>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import forgetPass from '@/components/forget-pass'
import setPass from '@/components/set-pass'
import { JUMP_URL } from '@/config/constant'
import Cookies from 'js-cookie'
export default {
  name: 'UserMenu',
  components: {
    forgetPass,
    setPass
  },
  data () {
    return {
      isDisplay: false,
      isSetDisplay: false,
      zMessageOption: {
        userId: '1234',
        token: 'token-demo',
        sysCode: '001',
      },
      hrefUrl: '',
      userInfo: {}
    }
  },
  computed: {
    ...mapState({
      userId: state => state.user.info.userId,
      avatar: state => state.user.avatar,
      marketCodes: state => state.user.marketCodes
    }),
  },
  created () {
    // 要从cookie里面取
    this.userInfo = Cookies.getJSON('AppUserInfo')
    this.hrefUrl = JUMP_URL + 'cloudStore' // 跳转到小易商城
  },
  methods: {
    ...mapActions(['Logout']),
    handleCommand (command) {
      this[`handle${command}`]()
    },
    handleLogout () {
      this.$confirm('真的要注销登录吗 ?', '提示').then(() => {
        this.Logout({})
      }).catch(() => {})
    },
    handleSetPass () {
      this.isDisplay = true
    },

    closeMain (e) {
      this.isDisplay = false
      this.isSetDisplay = false
    },
  },
}
</script>

<style lang="scss">
  .user-wrapper{
    .el-dropdown{
      color: rgba(51,51,51,0.65);
    }
    .el-form-item {
      margin-bottom: 0 !important;
    }
    .el-form--inline .el-form-item__label {
      margin-top: -19px !important;
    }
    .mall-btn {
      color: #ff5f00;
      text-decoration: none;
    }
  }
</style>
